export const APP_THEME_MAP = {
  acronis: 'acronis',
  virtuozzo: 'virtuozzo',
  'vz-converted': 'vz-converted',
} as const;

export const UIKIT_SCHEME_MAP = {
  BLUE_YELLOW_USS_SIGNAL: 'blue-yellow-uss-signal',
  BROWN: 'brown',
  DARK_GRAY: 'dark-gray',
  DEFAULT: 'default',
  DEEP_SKY_ITKONTORET: 'deep-sky-itkontoret',
  GREEN_ALSO_CHOISE_DF: 'green-also-choise-df',
  INGRAM_MICRO: 'ingram-micro',
  LIGHT_BLUE_HP: 'light-blue-hp',
  LIGHT_GRAY: 'light-gray',
  ORANGE_TSUKAERU_HELPOX: 'orange-tsukaeru-helpox',
  PURPLE: 'purple',
  PURPLE_FUSION_MEDIA: 'purple-fusion-media',
  RED_FIRE_BRICK: 'red-fire-brick',
  RED_HOME_PL: 'red-home-pl',
  SAND: 'sand',
  VIRTUOZZO: 'virtuozzo',
  YELLOW_1C: 'yellow-1c',
};

export const UIKIT_SCHEME_IMPORT_MAP = {
  [UIKIT_SCHEME_MAP.BLUE_YELLOW_USS_SIGNAL]: () => import('@uikit/ui-syntax/dist/js/colors/blue-yellow-uss-signal'),
  [UIKIT_SCHEME_MAP.BROWN]: () => import('@uikit/ui-syntax/dist/js/colors/brown'),
  [UIKIT_SCHEME_MAP.DARK_GRAY]: () => import('@uikit/ui-syntax/dist/js/colors/dark-gray'),
  [UIKIT_SCHEME_MAP.DEEP_SKY_ITKONTORET]: () => import('@uikit/ui-syntax/dist/js/colors/deep-sky-itkontoret'),
  [UIKIT_SCHEME_MAP.DEFAULT]: () => import('@uikit/ui-syntax/dist/js/colors/default'),
  [UIKIT_SCHEME_MAP.GREEN_ALSO_CHOISE_DF]: () => import('@uikit/ui-syntax/dist/js/colors/green-also-choise-df'),
  [UIKIT_SCHEME_MAP.INGRAM_MICRO]: () => import('@uikit/ui-syntax/dist/js/colors/ingram-micro'),
  [UIKIT_SCHEME_MAP.LIGHT_BLUE_HP]: () => import('@uikit/ui-syntax/dist/js/colors/light-blue-hp'),
  [UIKIT_SCHEME_MAP.LIGHT_GRAY]: () => import('@uikit/ui-syntax/dist/js/colors/light-gray'),
  [UIKIT_SCHEME_MAP.ORANGE_TSUKAERU_HELPOX]: () => import('@uikit/ui-syntax/dist/js/colors/orange-tsukaeru-helpox'),
  [UIKIT_SCHEME_MAP.PURPLE]: () => import('@uikit/ui-syntax/dist/js/colors/purple'),
  [UIKIT_SCHEME_MAP.PURPLE_FUSION_MEDIA]: () => import('@uikit/ui-syntax/dist/js/colors/purple-fusion-media'),
  [UIKIT_SCHEME_MAP.RED_FIRE_BRICK]: () => import('@uikit/ui-syntax/dist/js/colors/red-fire-brick'),
  [UIKIT_SCHEME_MAP.RED_HOME_PL]: () => import('@uikit/ui-syntax/dist/js/colors/red-home-pl'),
  [UIKIT_SCHEME_MAP.SAND]: () => import('@uikit/ui-syntax/dist/js/colors/sand'),
  [UIKIT_SCHEME_MAP.VIRTUOZZO]: () => import('@/hci/config/virtuozzoColorScheme'),
  [UIKIT_SCHEME_MAP.YELLOW_1C]: () => import('@uikit/ui-syntax/dist/js/colors/yellow-1c'),
};

const THEMES_LIST = [
  UIKIT_SCHEME_MAP.BLUE_YELLOW_USS_SIGNAL,
  UIKIT_SCHEME_MAP.BROWN,
  UIKIT_SCHEME_MAP.DARK_GRAY,
  UIKIT_SCHEME_MAP.DEEP_SKY_ITKONTORET,
  UIKIT_SCHEME_MAP.GREEN_ALSO_CHOISE_DF,
  UIKIT_SCHEME_MAP.INGRAM_MICRO,
  UIKIT_SCHEME_MAP.LIGHT_BLUE_HP,
  UIKIT_SCHEME_MAP.LIGHT_GRAY,
  UIKIT_SCHEME_MAP.ORANGE_TSUKAERU_HELPOX,
  UIKIT_SCHEME_MAP.PURPLE,
  UIKIT_SCHEME_MAP.PURPLE_FUSION_MEDIA,
  UIKIT_SCHEME_MAP.RED_FIRE_BRICK,
  UIKIT_SCHEME_MAP.RED_HOME_PL,
  UIKIT_SCHEME_MAP.SAND,
  UIKIT_SCHEME_MAP.YELLOW_1C,
];

export default THEMES_LIST;
